// @flow

import Price from "common/records/Price"
// Types
import type {
  FastTrackAncillaryItemInput,
  FastTrackAncillaryItem,
  FastTrackAncillaryInput,
  FastTrackAncillary,
} from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAncillary/components/FastTrack/consts/types"
import type { ServicePackagePriceInput } from "mmb/records/bookingInput"

export function fastTrackAncillayItemPrice(price: ServicePackagePriceInput): Price {
  return new Price({
    amount: Number(price.amount),
    base: Number(price.base),
    currency: price.currency,
    merchant: Number(price.merchant),
    service: Number(price.service),
    serviceFlat: Number(price.service_flat),
  })
}

export function fastTrackAncillayItem(
  items: Array<FastTrackAncillaryItemInput>,
): Array<FastTrackAncillaryItem> {
  return items.map(item => ({
    passengerId: item.passenger_id,
    price: fastTrackAncillayItemPrice(item.price),
    segmentCode: item.segment_code,
    stationCode: item.station_code,
  }))
}

export default function(fastTrack: FastTrackAncillaryInput): FastTrackAncillary {
  return fastTrack.map(item => ({
    id: item.id,
    extraId: item.extra_id,
    items: fastTrackAncillayItem(item.items),
    orderState: item.order_state,
    thirdPartyAncillaryOrderId: item.third_party_ancillary_order_id,
  }))
}
